import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Layers } from "lucide-react";

const fmtD = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");

export function LotesPedido({ pedidoId }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (pedidoId) { api.get(`/producao/pedidos/${pedidoId}/lotes`).then((r) => setD(r.data)).catch(() => setD(null)); } }, [pedidoId]);
  if (!d || !d.itens.length) return null;
  return (
    <Card className="bg-card/70 p-4 space-y-2" data-testid="rec-lotes-enviados">
      <div className="text-xs font-bold uppercase tracking-wide text-primary flex items-center gap-1"><Layers className="w-4 h-4" /> Lotes enviados pela Central</div>
      {d.itens.map((it) => (
        <div key={it.sku_id} className="text-sm">
          <div className="font-semibold">{it.item}</div>
          {it.lotes.map((l) => <div key={l.lote} className="flex justify-between text-xs font-mono" data-testid={`rec-lote-${l.lote}`}><span>Lote {l.lote}</span><span>val. {fmtD(l.validade)} · {l.qtd}</span></div>)}
        </div>
      ))}
      <div className="text-[11px] text-muted-foreground" data-testid="rec-limite-rastreio">{d.limite_rastreabilidade}</div>
    </Card>
  );
}
